<div class="container-fluid bg-white vh-100 p-0">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="Trust Name Search" />
    <div class="d-flex justify-content-center align-items-center min-vh-50">
        <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
            <div class="form-group mt-3">
                <form @submit.prevent="submit_trust_name">
                    <div class="form-group">
                        <label for="trust_name" class="fw-bold text-xs">Trust Name</label>
                        <input type="text" v-model="form.trust_name" class="form-control text-xs rounded-small p-3 shadow-sm" id="trust_name" required>
                    </div>
                    <div class="d-flex justify-content-center mb-3 mt-4">
                        <button type="submit" class="btn btn-bg-green btn-sm px-4 rounded-small shadow-sm fw-bold text-xs">
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>